export const countryData = [
  { name: "United States", flag: "🇺🇸", code: "US", dial_code: "+1", icon: "usa.png" },
  { name: "Canada", flag: "🇨🇦", code: "CA", dial_code: "+1", icon: "/canada.png" },
  { name: "United Kingdom", flag: "🇬🇧", code: "GB", dial_code: "+44", icon: "/uk.png" },
  { name: "France", flag: "🇫🇷", code: "FR", dial_code: "+33", icon: "/france.png" },
  { name: "Germany", flag: "🇩🇪", code: "DE", dial_code: "+49", icon: "/germany.png" },
  { name: "Spain", flag: "🇪🇸", code: "ES", dial_code: "+34", icon: "/spain.png" },
  { name: "Saudi Arabia", flag: "🇸🇦", code: "SA", dial_code: "+966", icon: "saudi.png" },
  { name: "United Arab Emirates", flag: "🇦🇪", code: "AE", dial_code: "+971", icon: "/uae.png" },
  { name: "Italy", flag: "🇮🇹", code: "IT", dial_code: "+39", icon: "/italy.png" },


];




